// extracted by mini-css-extract-plugin
export default {"header":"header_header","title":"header_title","btnLocation":"header_btnLocation","btnSettings":"header_btnSettings"};